<template>
    <vk-modal :show.sync="isOpen" v-if="document">
        <vk-modal-title slot="header">Edit Document - {{ document.filename }}</vk-modal-title>
        <div class="uk-grid">

            <div class="uk-width-1-1 uk-margin-large-bottom">
                <div v-if="isValid">
                    <iframe v-if="isPdf" style="width: 100%; height: 800px;" :src="url" frameborder="0"></iframe>
                    <div class="image-container" v-else>
                        <inner-image-zoom :src="rotatedUrl">
                        </inner-image-zoom>
                        <button class="uk-button uk-button-primary uk-align-right" @click="rotate(-90)">
                            <i class="a-rotate-right-2"></i>
                        </button>
                        <button class="uk-button uk-button-primary uk-align-right" @click="rotate(90)">
                            <i class="a-rotate-left"></i>
                        </button>
                        <button class="uk-button uk-button-primary uk-align-right" @click="downloadDocument">
                            <i class="a-download-2"></i>
                        </button>
                        <button class="uk-button uk-button-primary uk-align-right" @click="deleteDocument">
                            <i class="a-trash-2"></i>
                        </button>
                    </div>
                </div>
                <div v-else class="uk-tile uk-tile-muted uk-text-large uk-text-center uk-padding">
                    No Preview Available For This File Type
                </div>
            </div>
            <div class="uk-width-1-2 ">
                <label class="uk-margin-bottom">Document Request</label>
                <select v-model="document.household_application_document_request_id" class="uk-select">
                    <option v-for="req in documentRequests" :value="req.id" v-if="req.household_member">
                        {{ req.household_member.first_name }} {{
                        req.household_member.last_name }} - {{ req.category.document_category_name }}
                    </option>
                </select>
            </div>
            <div class="uk-width-1-2 uk-margin-large-bottom">
                <label class="uk-margin-bottom">Note</label>
                <textarea class="uk-textarea" v-model="document.comment"></textarea>
            </div>
            <div class="uk-width-1-1 uk-margin-large-bottom">
                <button @click="updateStatus(document, 'approved')" :class="{'uk-button': true, 'uk-button-small': true, 'uk-button-primary': document.approved == 1}">Approved</button>
                <button @click="updateStatus(document, 'declined')" :class="{'uk-button': true, 'uk-button-small': true, 'uk-button-primary': document.notapproved == 1}">Declined</button>
                <button @click="clearStatus(document)" :class="{'uk-button': true, 'uk-button-small': true,}" >Clear Status</button>
            </div>
        </div>
        <div slot="footer" class="uk-text-right">
            <vk-button class="uk-margin-small-right" @click="isOpen = false">{{ cancelText }}</vk-button>
            <vk-button type="primary" @click="onConfirm">{{ confirmText }}</vk-button>
        </div>
    </vk-modal>
</template>

<script>
    import {mapState} from 'vuex';
    import 'vue-inner-image-zoom/lib/vue-inner-image-zoom.css';
    import InnerImageZoom from 'vue-inner-image-zoom';

    export default {
        name: "EditDocumentsModal",
        components: {InnerImageZoom},
        props: {
            show: {
                type: Boolean,
                default: false,
            },
            cancelText: {
                type: String,
                default: 'Cancel',
            },
            confirmText: {
                type: String,
                default: 'Ok',
            },
        },
        data() {
            return {
                isOpen: false,
                document: null,
                url: null,

                panZoomOptions: {
                    minZoom: 0.5,
                    maxZoom: 5,
                },
                rotation: 0,
            }
        },
        computed: {
            isValid() {
                let isValid = false;
                let validExtensions = ['pdf', 'jpg', 'png', 'jpeg'];
                _.each(validExtensions, ext => {
                    if(this.document.filename.indexOf('.'+ext) !== -1) {
                        isValid = true;
                    }
                })
                return isValid;
            },
            isPdf() {
                if (this.document) {
                    return this.document.filename.indexOf('.pdf') !== -1;
                }

                return false;
            },
            rotatedUrl() {
                return this.url + '?rotate=' + this.rotation;
            },
            ...mapState('Application', {
                application: 'application',
                documentRequests: 'documentRequests',
            })
        },
        watch: {
            show(newValue) {
                this.isOpen = newValue;
            }
        },
        mounted() {
            this.isOpen = this.show;
        },
        methods: {
            open(url, document) {
                console.log('opening');
                this.document = document;
                this.isOpen = true;
                this.url = url;
            },
            close() {
                this.isOpen = false;
            },
            onConfirm() {
                axios.put(`/api/applications/${this.application.id}/documents/${this.document.id}`, this.document)
                    .then(r => {
                        this.$emit('confirm');
                        this.isOpen = false;
                    })

            },
            rotate(amount) {
                this.rotation += amount;
            },
            updateStatus(doc, status) {
                let url = status == 'approved'
                    ? `/api/applications/${this.application.id}/documents/${doc.id}/approve`
                    : `/api/applications/${this.application.id}/documents/${doc.id}/decline`;

                axios.post(url).then(r => {
                    this.$emit('statusUpdated');
                    this.document = r.data.document;
                });
            },
            clearStatus(doc) {
                let url = `/api/applications/${this.application.id}/documents/${doc.id}/clear-status`
                axios.post(url).then(r => {
                    this.$emit('statusUpdated');
                    this.document = r.data.document;
                });
            },

            downloadDocument() {
                window.open(`/applicant/download-local-document/${this.document.id}`, '_blank')
            },
            deleteDocument() {
                this.$swal({
                    title: 'Are you sure?',
                    body: 'This will delete this document from the system forever.',
                    confirmText: 'Yes I am sure.',
                    cancelText: 'Cancel',
                    showCancelButton: true,
                }).then(r => {
                    if(r.isConfirmed) {
                        axios.delete(`/api/applications/${this.application.id}/documents/${this.document.id}`).then(r => {
                            this.$emit('confirm');
                            this.isOpen = false;
                        })
                    }
                })
            },
        },
    }
</script>

<style scoped lang="scss">

</style>
